// extracted by mini-css-extract-plugin
export default {"inner_table":"tinyTable_inner_table__nFbde"};